import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "contexts/AuthContext";
import AuthLoading from "components/common/AuthLoading";
import paths from "routes/paths";

const RequireAuth = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <AuthLoading />;
  }

  if (!isAuthenticated) {
    return <Navigate to={paths.authLanding} replace state={{ from: location }} />;
  }

  return children;
};

export default RequireAuth;
